import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';
import { MapContainer } from './OpenSearchMap.style';

const MOB_BREAKPOINT = 1339;

export const Container = styled.div`
  display: flex;
  margin: 0 0 30px;
  gap: 30px;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1;
  max-width: calc(100% - 330px);

  ${MapContainer} {
    display: none;
  }

  @media (max-width: ${MOB_BREAKPOINT}px) {
    flex: 1;
    max-width: 100%;

    ${MapContainer} {
      display: block;
    }
  }
`;

export const BoxList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (${mobileXXLargeMax}) {
    margin: 0 -15px 30px;
    max-width: 100vw;
    flex: 0 0 100vw;
  }
`;

export const HandyTools = styled.div`
  display: flex;
  flex: 0 0 300px;
  flex-direction: column;
  gap: 30px;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    max-width: none;
  }
`;

export const DesktopOnly = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 30px;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    display: none;
  }
`;

export const StickyBox = styled.div`
  position: sticky;
  top: ${platform.select('15px', '85px')};
  left: 0;
`;

export const InfoBox = styled.div`
  background-color: ${({ theme }) => theme.background};
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: stretch;

  button,
  a {
    display: block;
    font-size: 16px;
    color: ${({ theme }) => theme.textDark};
    text-align: left;

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    vertical-align: bottom;
  }
`;

export const AdContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoHeader = styled.h3`
  margin: -20px -20px 0 -20px;
  padding: 20px;
  color: ${({ theme }) => theme.textDark};
  border-bottom: 1px solid ${({ theme }) => theme.backgroundLighter};
`;

export const RecentSearchButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;

  h4 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }

  svg {
    margin-top: 2px;
  }
`;
